module.exports = __webpack_public_path__ + "img/ResourceWood_ua.178999be.webp";